import React, { useContext } from 'react';

import { LocationContext } from 'common/containers/RouterContainer';
import { TPCForFiltersContext } from 'common/containers/TPCForFiltersContainer';
import Tag from 'common/tags/Tag';
import styles from 'css-module/components/subdomain/admin/AdminSideBar/_CompanyFilterSection.module.scss';

type Props = {
  companySelected: (companyUrlName: string) => void;
};

const CompanyFilterSelections = ({ companySelected }: Props) => {
  const location = useContext(LocationContext);

  const { companies } = useContext(TPCForFiltersContext);

  const companiesQuery: string = location.query?.companies ?? null;

  const selectedCompanies = companiesQuery
    ? companiesQuery
        .split('_')
        .filter((companyURLName: string) => {
          return companies[companyURLName];
        })
        .map((companyURLName) => {
          const company = companies[companyURLName];
          return (
            <Tag
              key={company.urlName}
              name={company.name}
              onTap={() => companySelected(company.urlName)}
              selected={true}
            />
          );
        })
    : [];

  if (selectedCompanies.length === 0) {
    return null;
  }

  return <div className={styles.companyFilterSectionTagWrapper}>{selectedCompanies}</div>;
};

export default CompanyFilterSelections;
